// Config for detectors created through: Explore Page -> Quick Start
// If set, this will explicitly override the DEFAULT_PIPELINE_CONFIG setting
// in Janzu.  In the past we have had reason to do this.
// Currently the explore page is using the system default.
export const DEFAULT_EXPLORE_PAGE_PREDICTOR_CONFIG = {
  // pipeline_config: "groundlight-default-current",
};

export function getConfig(): Window["REACT_APP_CONFIG"] {
  // These would only apply for when unit tests are ran.
  // If env mode is test we need to set all variables to avoid test erros
  if (process.env.NODE_ENV === "test") {
    // TODO: We should review this hardcoded url, I prefer to not move it for now since it was a fix on tests
    const janzuUrl = `${process.env.REACT_APP_POSITRONIX_API_URL}/`;
    const logoutUrl = `${process.env.REACT_APP_AUTH_URL_BASE}/logout?client_id=${process.env.REACT_APP_COGNITO_CLIENT_ID}&logout_uri=${janzuUrl}reef/logout`;

    return {
      REACT_APP_POSITRONIX_API_URL: process.env.REACT_APP_POSITRONIX_API_URL || "",
      REACT_APP_AUTH_URL_BASE: process.env.REACT_APP_AUTH_URL_BASE || "",
      REACT_APP_FUSIONAUTH_URL_BASE: process.env.REACT_APP_FUSIONAUTH_URL_BASE || "",
      REACT_APP_COGNITO_CLIENT_ID: process.env.REACT_APP_COGNITO_CLIENT_ID || "",
      REACT_APP_FUSIONAUTH_CLIENT_ID: process.env.REACT_APP_FUSIONAUTH_CLIENT_ID || "",
      REACT_APP_SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN || "",
      REACT_APP_DISABLE_ROI_UI: process.env.REACT_APP_DISABLE_ROI_UI || "",
      REACT_APP_MUI_LICENSE_KEY: process.env.REACT_APP_MUI_LICENSE_KEY || "",
      REACT_APP_STAGE: process.env.REACT_APP_STAGE || "",
      REACT_APP_LOGOUT_URL: logoutUrl,
      REACT_APP_BASE_PREFIX: "/reef",
      JANZU_URL: janzuUrl,
    };
  }

  // Set authenticator based on application url
  if (!window.authenticator) {
    window.authenticator = window.location.href.includes("dashboard") ? "fusionauth" : "cognito";
  }

  // These would apply when the app is run on a live environment on a browser.
  const baseUrl = `${window.REACT_APP_CONFIG.REACT_APP_POSITRONIX_API_URL}/`;

  window.REACT_APP_CONFIG.JANZU_URL =
    window.authenticator === "fusionauth" ? baseUrl.replace("app", "dashboard") : baseUrl.replace("dashboard", "app");

  window.REACT_APP_CONFIG.REACT_APP_LOGOUT_URL =
    window.authenticator === "fusionauth"
      ? `${window.REACT_APP_CONFIG.REACT_APP_FUSIONAUTH_URL_BASE}/oauth2/logout?client_id=${window.REACT_APP_CONFIG.REACT_APP_FUSIONAUTH_CLIENT_ID}&post_logout_redirect_uri=${window.REACT_APP_CONFIG.JANZU_URL}device-api/authz/callback`
      : `${window.REACT_APP_CONFIG.REACT_APP_AUTH_URL_BASE}/logout?client_id=${window.REACT_APP_CONFIG.REACT_APP_COGNITO_CLIENT_ID}&logout_uri=${window.REACT_APP_CONFIG.JANZU_URL}reef/logout`;

  window.REACT_APP_CONFIG.REACT_APP_BASE_PREFIX = "/reef";

  return window.REACT_APP_CONFIG;
}

export const { JANZU_URL, REACT_APP_STAGE, REACT_APP_LOGOUT_URL } = getConfig();
